import * as React from 'react';
import warning from 'tiny-warning';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function deprecatedComponent(_ref) {
  let {
    root: WrappedComponent,
    displayName,
    description
  } = _ref;
  const DeprecatedComponent = /*#__PURE__*/React.forwardRef((props, forwardedRef) => {
    React.useEffect(() => {
      warning(props.__dangerouslySuppressWarning, "".concat(displayName, " is Deprecated. ").concat(description));
    }, [props.__dangerouslySuppressWarning]);
    const forwardedProps = props;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, forwardedProps, {
      ref: forwardedRef
    }));
  });
  DeprecatedComponent.displayName = "deprecated(".concat(WrappedComponent.displayName, ")");
  return DeprecatedComponent;
}
export { deprecatedComponent };